import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { InstituteManagementSandbox } from 'src/app/pages/institute-mangements/institute-management.sandbox';
import { InstituteManagementService } from 'src/app/pages/institute-mangements/institute-management.service';

@Component({
  selector: 'app-support-remarks',
  templateUrl: './support-remarks.component.html',
  styleUrls: ['./support-remarks.component.scss']
})
export class SupportRemarksComponent implements OnInit {

  instituteId: any;
  userId: any;
  remarks: any = '';
  supportType: any = '';
  supportName: any = '';
  norecord: any = true;
  displayList: any = [];
  public subscriptions: Array<Subscription> = [];

  showDefaultOtpModel = false;
  showRemoveDefaultOtpModel = false;
  defaultOtpReason: any;
  defaultOtpReasonError: any;
  isDefaultOtpActive: boolean = false;
  defaultOtpInstituteId: any = null;
  defaultOtpSetReason: string = '';
  defaultOtpSetOn: string = '';
  Loading: boolean = false;
  mobileNumber: any = '';
  otp: any = 0;
  password: any = 0;
  instituteDetails: any = {};
  loggedInStaffId: any;

  constructor(
    public activeModal: NgbActiveModal,
    public instituteManagementSandbox: InstituteManagementSandbox,
    private instituteManagementService: InstituteManagementService
  ) { }


  ngOnInit() {
    const param: any = {};
    param.institute_id = this.instituteId;
    this.getSupportList(param);

    this.otp = (this.instituteDetails && (this.instituteDetails.otp || this.instituteDetails.OTP)) || 0;
    this.password = (this.instituteDetails && this.instituteDetails.password) || 0;
    this.mobileNumber = (this.instituteDetails && (this.instituteDetails.instituteContactNumber1 || this.instituteDetails.instituteContactNumber2 || this.instituteDetails.mobile || this.instituteDetails.mobileNumber)) || '';

    if (this.instituteId) {
      this.checkDefaultOtpStatus(this.instituteId);
    }
  }


  types = [
    { value: 'New Development', viewValue: 'New Development' },
    { value: 'Customization', viewValue: 'Customization' },
    { value: 'Support Query', viewValue: 'Support Query' },
    { value: 'School Mistake Correction', viewValue: 'School Mistake Correction' },
    { value: 'Technical Correction/Bug Finds', viewValue: 'Technical Correction/Bug Finds' }
  ];

  userText(event: Event) {
    const input = event.target as HTMLTextAreaElement;
    this.remarks = input.value;
  }

  userName(event: Event) {
    const input = event.target as HTMLInputElement;
    this.supportName = input.value;
  }

  getSupportList(param: any) {
    this.subscriptions.forEach(s => s.unsubscribe());
    this.subscriptions = [];
    this.instituteManagementSandbox.getSupportRemaks(param);
    const sub = this.instituteManagementSandbox.getsupportremarks$.subscribe(details => {
      if (details && details.data && details.data.length > 0) {
        this.displayList = [...details.data];
        this.norecord = false;
      } else {
        this.displayList = [];
        this.norecord = true;
      }
    })
    this.subscriptions.push(sub);
  }


  remarksvalid: boolean = false;
  supporttypevalid: boolean = false;
  supportNamevalid: boolean = false;
  submit() {
    this.remarksvalid = false;
    this.supporttypevalid = false;
    this.supportNamevalid = false;
    if (!this.remarks || this.remarks.trim() === '') {
      this.remarksvalid = true;
      return false;
    }
    if (!this.supportType || this.supportType.trim() === '') {
      this.supporttypevalid = true;
      return false;
    }
    if (!this.supportName || this.supportName.trim() === '') {
      this.supportNamevalid = true;
      return false;
    }

    const params: any = {};
    params.instituteId = this.instituteId;
    params.remarks = this.remarks;
    params.userId = this.userId;
    params.supportType = this.supportType;
    params.supportName = this.supportName;
    this.instituteManagementSandbox.createSupportRemarks(params);
    this.close()
  }
  close() {
    this.activeModal.close();
  }

  openDefaultOtpModel() {
    this.showDefaultOtpModel = true;
    this.defaultOtpReason = '';
    this.defaultOtpReasonError = '';
  }

  closeDefaultOtpModel() {
    this.showDefaultOtpModel = false;
    this.defaultOtpReason = '';
    this.defaultOtpReasonError = '';

  }

  openRemoveDefaultOtpModel() {
    this.showRemoveDefaultOtpModel = true;
  }

  closeRemoveDefaultOtpModel() {
    this.showRemoveDefaultOtpModel = false;
  }

  removeDefaultOtp() {
    this.openRemoveDefaultOtpModel();
  }

  confirmRemoveDefaultOtp() {
    if (!this.instituteId) {
      return;
    }

    this.Loading = true;
    const params: any = { institute_id: this.instituteId };

    this.instituteManagementService.removeDefaultOtpInstitute(params).subscribe(
      (data: any) => {
        this.Loading = false;
        if (data && (data.status == 1 || data.status === '1')) {
          this.closeRemoveDefaultOtpModel();
          this.checkDefaultOtpStatus(this.instituteId);
          this.getSupportList({ institute_id: this.instituteId });
        }
      },
      (error: any) => {
        this.Loading = false;
        const errorMessage = (error && error.error && error.error.message) || error && error.message || 'Unable to remove default OTP. Please try again.';
        this.defaultOtpReasonError = errorMessage;
      }
    );
  }

  checkDefaultOtpStatus(instituteId: any) {
    if (!instituteId) {
      this.isDefaultOtpActive = false;
      return;
    }

    this.instituteManagementService.getDefaultOtpStatusInstitute(instituteId.toString().trim()).subscribe(
      (data: any) => {
        if (data && (data.status === '1' || data.status === 1)) {
          this.isDefaultOtpActive = +data.is_default_otp === 1;
          this.defaultOtpInstituteId = data.institute_id || null;
          this.defaultOtpSetReason = data.reason || '';
          this.defaultOtpSetOn = data.created_on || '';
        } else {
          this.isDefaultOtpActive = false;
          this.defaultOtpInstituteId = null;
          this.defaultOtpSetReason = '';
          this.defaultOtpSetOn = '';
        }
      },
      () => {
        this.isDefaultOtpActive = false;
        this.defaultOtpInstituteId = null;
        this.defaultOtpSetReason = '';
        this.defaultOtpSetOn = '';
      }
    );
  }

  confirmDefaultOtp() {
    if (!this.defaultOtpReason || this.defaultOtpReason.trim() == '') {
      this.defaultOtpReasonError = 'Please enter reason';
      return;
    }
    if (!this.mobileNumber) {
      this.defaultOtpReasonError = 'Mobile number not available';
      return;
    }

    this.Loading = true;
    const params: any = {};
    params.institute_id = this.instituteId;
    params.reason = this.defaultOtpReason;

    this.instituteManagementService.setDefaultOtpInstitute(params).subscribe(data => {
      this.Loading = false;
      if (data && data.status == 1) {
        this.closeDefaultOtpModel();
        this.checkDefaultOtpStatus(this.instituteId);
        this.getSupportList({ institute_id: this.instituteId });
      } else {
        this.defaultOtpReasonError = data.message ? data.message : 'Something went wrong, please try again';
      }
    }, (error: any) => {
      this.Loading = false;
      const errorMessage = (error && error.error && error.error.message) || error && error.message || 'API error. Please try again.';
      this.defaultOtpReasonError = errorMessage;
    });
  }

}
